<template>
    <label
        :class="{
            'input': true,
            'input--disabled': disabled,
        }"
    >
        <textarea
            v-if="multiline"
            :class="{
                'input__element': true,
                'input__element--active': value,
            }"
            :rows="multilineRows"
            :name="name"
            :id="id"
            :value="value"
            @input="$emit('input', $event.target.value)"
            :disabled="disabled"
        ></textarea>

        <input
            v-else
            :class="{
                'input__element': true,
                'input__element--active': value,
            }"
            :type="type"
            :name="name"
            :id="id"
            :value="value"
            @input="$emit('input', $event.target.value)"
            :step="step"
            :min="min"
            :max="max"
            :disabled="disabled"
            ref="inputElement"
            />

        <span class="input__label" >{{ placeholder }}</span>
        <div class="input__bar"></div>
    </label>
</template>

<script>

export default {
    name: 'InputElement',
    components: {

    },
    props: {
        placeholder: String,
        disabled: Boolean,
        type: {
            type: String,
            default: 'text'
        },
        name: {
            type: String,
            required: true
        },
        value: {
            type: String|Number,
            default: ''
        },
        id: String,
        step: Number,
        min: Number,
        max: Number,
        multiline: {
            type: Boolean,
            default: false
        },
        multilineRows: {
            type: Number,
            default: 3
        }
    },

    data: () => {
        return {
            inputValue: ''
        }
    },

    created() {

    },
    mounted() {

    },
    methods: {

    },
}
</script>
